import React, { useState } from 'react';
import { BotaoComClose, Spinner } from '../../StyledComponent';
import { Link } from 'react-router-dom';
import Cognito from '../../..//Amplify';
import PassVerificationWithModal from '../../PassVerificationWithModal';
import MsgSucessoTrocaSenha from '../MsgSucessoTrocaSenha';
import EmailSend from '../EmailSend';

import Fade from '@material-ui/core/Fade';
import Close from '../../Reutilizaveis/CloseButton';
import PrecisaAjuda from '../../PrecisaDeAjuda';

import Input from '../../Reutilizaveis/Input';

const EmailSent = ({ codigo, email }) => {
  const [invalidCode, setInvalidCode] = useState(false);
  const [senha, setSenha] = useState('');
  const [confirmNovaSenha, setConfirmNovaSenha] = useState('');
  const [msgSenhasDiferentes, setMsgSenhasDiferentes] = useState('');
  const [loading, setLoading] = useState(false);
  const [msgSucessoTrocaSenha, setMsgSucessoTrocaSenha] = useState(false);
  const [approved, setApproved] = useState(false);
  const [regras, setRegras] = useState(false);

  async function trocaNewPassword() {
    let troca = '';
    try {
      troca = await Cognito.confirmForgotPassword(email, codigo, senha);
      return troca;
    } catch (error) {
      return error;
    }
  }

  const trocaSenha = async () => {
    setLoading(true);

    let resultTrocaSenha = '';

    resultTrocaSenha = await trocaNewPassword();
    if (resultTrocaSenha === undefined) {
      setLoading(false);
      setMsgSucessoTrocaSenha(true);
    } else if (
      resultTrocaSenha.code === 'ExpiredCodeException' ||
      resultTrocaSenha.code === 'CodeMismatchException'
    ) {
      mensagemDeErro('Código inválido');
      setInvalidCode(true);
    } else if (resultTrocaSenha.code === 'LimitExceededException') {
      mensagemDeErro(
        'Limite de tentativas excedido. Tente novamente mais tarde.'
      );
    }
  };

  function mensagemDeErro(text) {
    setLoading(false);
    setMsgSenhasDiferentes(text);
  }

  async function handleSubmit() {
    setMsgSenhasDiferentes('');
    await trocaSenha();
  }

  return (
    <>
      {invalidCode ? (
        <EmailSend
          email={email}
          codigoInvalido={invalidCode}
          codigoAntigo={codigo}
        />
      ) : (
        <>
          {msgSucessoTrocaSenha && <MsgSucessoTrocaSenha />}
          {!msgSucessoTrocaSenha && (
            <Fade in>
              <div className='loginForm loginForgotPassword'>
                <div className='nova-senha centralized-column'>
                  <h1>Alterar senha:</h1>

                  <div
                    className='centralized-column'
                    style={{ marginBottom: '15px' }}
                  >
                    <div className='centralized-column nova-senha__containerNovaSenha'>
                      <Input
                        value={senha}
                        setValue={setSenha}
                        placeholder='Senha'
                        required
                        id='txtPassword'
                        type='password'
                      />

                      <Input
                        value={confirmNovaSenha}
                        setValue={setConfirmNovaSenha}
                        placeholder='Confirme sua senha'
                        required
                        id='txtConfirmPassword'
                        type='password'
                      />
                    </div>
                  </div>
                  <PassVerificationWithModal
                    newPassword={senha}
                    setApproved={setApproved}
                    confirmNewPassword={confirmNovaSenha}
                    setRegras={setRegras}
                    regras={regras}
                  />
                  {!regras && (
                    <>
                      <div
                        className='centralized-column'
                        style={{
                          height: '25px',
                          justifyContent: 'space-evenly',
                        }}
                      >
                        <span
                          onClick={() => {
                            setRegras(true);
                          }}
                          style={{
                            fontSize: '10px',
                            transition: '0.3s',
                            color:
                              senha != '' && confirmNovaSenha != ''
                                ? '#B61817'
                                : '#1d3054',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            fontWeight: '900',
                          }}
                        >
                          Regras para construção da senha:
                        </span>
                      </div>
                      <div className='centralized'>
                        {loading ? (
                          <Spinner />
                        ) : (
                          <div className='centralized'>
                            <Link to='/'>
                              <Close
                                id='btnCancelForgotPassword'
                                tamanho='35px'
                                tamanhoIcone='25px'
                              />
                            </Link>
                            <BotaoComClose
                              color='#ffffff'
                              className='btnSubmit'
                              id='btnSaveNewPassword'
                              disabled={approved ? false : true}
                              onClick={handleSubmit}
                            >
                              <span>
                                {msgSenhasDiferentes != ''
                                  ? msgSenhasDiferentes
                                  : 'SALVAR NOVA SENHA'}
                              </span>
                            </BotaoComClose>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  <PrecisaAjuda posicaoY={'5%'} />
                </div>
              </div>
            </Fade>
          )}
        </>
      )}
    </>
  );
};

export default EmailSent;
